export default "__VITE_ASSET__CnRnzJSD__"